export default class AuthError extends Error {
  constructor(message = 'Ocurrió un error al procesar tu solicitud. Intenta de nuevo más tarde') {
    super(message);
    this.name = 'AuthError';
  }
}
